import { eyebrowStyle, h2Style, subtitleStyle, chipStyle, cardStyle, primaryBtnStyle } from './tokens';
import { topicLabel } from './tokens';

/**
 * SimilarQuestionsModal — shown BEFORE posting a new question when
 * the community appears to already have similar ones.
 * Options: View a similar question · Post Anyway · Cancel.
 */
export default function SimilarQuestionsModal({ similar, onDismiss, onPostAnyway, onOpen, posting }) {
  return (
    <div
      onClick={onDismiss}
      data-testid="similar-questions-modal"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(14,15,19,.45)', zIndex: 9998,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 480, background: '#fff', borderRadius: 20,
          padding: '22px 20px 24px', maxHeight: '85vh', overflowY: 'auto',
          boxShadow: '0 24px 60px rgba(0,0,0,.28)',
        }}
      >
        <div style={eyebrowStyle}>SIMILAR QUESTIONS FOUND</div>
        <h2 style={{ ...h2Style, marginTop: 6 }}>Someone may have asked this already.</h2>
        <p style={{ ...subtitleStyle, marginBottom: 14 }}>Have a look — you might find your answer faster.</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 18 }}>
          {similar.map((s) => (
            <button
              key={s.id}
              onClick={() => onOpen(s)}
              data-testid={`similar-q-${s.id}`}
              style={{ ...cardStyle, padding: 14, textAlign: 'left', cursor: 'pointer', border: '1px solid rgba(0,0,0,.06)' }}
            >
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                <span style={chipStyle}>{topicLabel(s.topic)}</span>
              </div>
              <div style={{ fontSize: 14.5, fontWeight: 600, color: '#232323', lineHeight: 1.35 }}>{s.title}</div>
            </button>
          ))}
        </div>

        <button
          onClick={onPostAnyway}
          disabled={posting}
          data-testid="similar-post-anyway"
          style={{ ...primaryBtnStyle, opacity: posting ? 0.5 : 1, cursor: posting ? 'wait' : 'pointer' }}
        >
          {posting ? 'Posting…' : 'Post Anyway'}
        </button>
        <button
          onClick={onDismiss}
          disabled={posting}
          data-testid="similar-dismiss"
          style={{
            width: '100%', marginTop: 10, padding: 12, borderRadius: 999,
            background: 'transparent', border: 'none', color: '#6D5EF5',
            fontSize: 13, fontWeight: 600, cursor: posting ? 'wait' : 'pointer', fontFamily: 'inherit',
          }}
        >
          Keep editing
        </button>
      </div>
    </div>
  );
}
